import { defineMessages } from 'react-intl'

export const HeaderLinkMessages = defineMessages({
  jobsLink: {
    id: 'headerLinks.jobsLink',
    description: 'Text for job/homes link in header',
    defaultMessage: 'Jobs & Homes',
  },
  templatesLink: {
    id: 'headerLinks.templatesLink',
    description: 'Text for templates link in header',
    defaultMessage: 'Templates',
  },
  profilesLink: {
    id: 'headerLinks.profilesLink',
    description: 'Text for profiles link in header',
    defaultMessage: 'Profiles',
  },
  licensesLink: {
    id: 'headerLinks.licensesLink',
    description: 'Text for licenses link in header',
    defaultMessage: 'Licenses',
  },
  teamLink: {
    id: 'headerLinks.teamLink',
    description: 'Text for team link in header',
    defaultMessage: 'Team',
  },
  auditLink: {
    id: 'headerLinks.auditLink',
    description: 'Text for audit link in header',
    defaultMessage: 'Audit',
  },
})
